import React, { createContext, useState } from "react";

export const ModalContext = createContext();

const ModalContextProvider = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fnId, setFnId] = useState("");
  const [headline, setHeadline] = useState("");
  const [content, setContent] = useState("");

  const openModal = () => {
    fetch(`${process.env.REACT_APP_FOOTNOTES_URL}/${fnId}`)
      .then((response) => response.json())
      .then((data) => {
        setHeadline(data.headline);
        setContent(data.text);
        setIsModalOpen(true);
      });
  };

  const contextValues = {
    openModal,
    isModalOpen,
    headline,
    content,
    setIsModalOpen,
    setHeadline,
    setContent,
    setFnId,
  };

  return (
    <ModalContext.Provider value={contextValues}>
      {children}
    </ModalContext.Provider>
  );
};

export default ModalContextProvider;